import { NgModule } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrimengModule } from './primeng.module';

import { MessageComponent } from './components/message/message.component';
import {RippleModule} from "primeng/ripple";
import { LoadingComponent } from './components/loading/loading.component';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { TipoItemDialogComponent } from './components/tipo-item-dialog/tipo-item-dialog.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { TipoItemDialogService } from './components/tipo-item-dialog/tipo-item-dialog.service';
import { TipoMovimientoDialogComponent } from './components/tipo-movimiento-dialog/tipo-movimiento-dialog.component';
import { TipoMovimeintoDialogService } from './components/tipo-movimiento-dialog/tipo-movimiento-dialog.service';
import { BankDialogComponent } from './components/bank-dialog/bank-dialog.component';
import { BankDialogService } from './components/bank-dialog/bank-dialog.service';
import { ItemDialogComponent } from './components/item-dialog/item-dialog.component';
import { ItemDialogService } from './components/item-dialog/item-dialog.service';
import { CompanyDialogComponent } from './components/company/company-dialog.component';
import { CompanyDialogService } from './components/company/company-dialog.service';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { ListSkeletonComponent } from './components/list-skeleton/list-skeleton.component';
import { TableSkeletonComponent } from './components/table-skeleton/table-skeleton.component';
import { FormSkeletonComponent } from './components/form-skeleton/form-skeleton.component';

import { EmailValidatorDirective } from './directives/validators/email/email-validator.directive.ts.directive';
import { OnlyNumbersDirective } from './directives/validators/only-numbers/only-numbers.directive.ts.directive';

@NgModule({
  imports: [
    SkeletonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PrimengModule,
    RippleModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBackgroundColour: 'rgba(0,0,0,0.5)',
      backdropBorderRadius: '4px',
      tertiaryColour: '#1976d2',
      fullScreenBackdrop: true,
    }),
  ],
  declarations: [
    MessageComponent,
    LoadingComponent,
    ErrorPageComponent,
    TipoItemDialogComponent,
    TipoMovimientoDialogComponent,
    BankDialogComponent,
    ItemDialogComponent,
    CompanyDialogComponent,
    DropdownComponent,
    FileUploadComponent,
    ListSkeletonComponent,
    TableSkeletonComponent,
    FormSkeletonComponent,

    EmailValidatorDirective,
    OnlyNumbersDirective,
  ],
  exports: [
    SkeletonModule,
    CommonModule,
    RouterModule,
    PrimengModule,
    RippleModule,
    MessageComponent,
    LoadingComponent,
    ErrorPageComponent,
    TipoItemDialogComponent,
    CompanyDialogComponent,
    TipoMovimientoDialogComponent,
    BankDialogComponent,
    ItemDialogComponent,
    DropdownComponent,
    FileUploadComponent,
    ListSkeletonComponent,
    TableSkeletonComponent,
    FormSkeletonComponent,

    EmailValidatorDirective,
    OnlyNumbersDirective,
  ],
  providers: [
    TipoItemDialogService,
    TipoMovimeintoDialogService,
    BankDialogService,
    ItemDialogService,
    CompanyDialogService
  ]
})
export class SharedModule { }
